import { Component } from '@angular/core';
import { NHMRC_PAGE_URL_EXTERNAL } from 'src/app/models/external-urls';

@Component({
  selector: 'app-water-monitoring-landing',
  templateUrl: './water-monitoring-landing.component.html',
  styleUrls: ['./water-monitoring-landing.component.scss']
})
export class WaterMonitoringLandingComponent {
  public NHMRC_PAGE_URL = NHMRC_PAGE_URL_EXTERNAL;
}
